export const setRegisterEmail = (value: string) => value && localStorage.setItem("email", value);
export const getRegisterEmail = () => localStorage.getItem("email");

export const setRegisterUserId = (value: string) => value && localStorage.setItem("user_id", value);
export const getRegisterUserId = () => localStorage.getItem("user_id");
export enum roleNames {
  provider = "provider",
  client = "client",
  liveStream = "live-stream",
}

// Providers whose claim is not yet completed (is_claim_done === false) bypass
// the entire post-login restriction flow (license check, sidebar restriction,
// warning toaster and the subscription-inactive redirect). For them we log in
// normally and treat the account as unrestricted regardless of the
// account_restricted / subscription_status values returned by the API.
// (is_claimed_user is used only as the logged-in/claimed-account check, not here.)
export const isClaimPendingUser = (userDetails: any): boolean =>
  userDetails?.is_claim_done === false;

export const roleType = () => {
  const role = window.location?.pathname?.split("/")[1] || "";
  const isClient = localStorage.getItem("role");
  return role === roleNames.client || role === roleNames.liveStream || isClient === "client"
    ? roleNames.client
    : roleNames.provider;
};

export enum socialType {
  google = "Google",
  normal = "normal",
}

export enum tabId {
  About = "about",
  Specialties = "specialties",
  Treatment = "treatment",
  Video = "video",
  Articles = "articles",
  Announcements = "announcements",
  Events = "events",
  Support = "support",
}
export enum commonWords {
  exclusive = "Exclusive",
  subscribe = "Subscribe",
  follow = "Follow",
  following = "Following",
  subscribed = "Subscribed",
  filterCountryFeeds = "FilterCountryFeeds",
  feeds = "Feeds",
  nationalFeeds = "NationalFeeds",
  localFeeds = "LocalFeeds",
  globalFeeds = "GlobalFeeds",
  viewAllFeeds = "ViewAllFeeds",
  subcategory = "Subcategory",
  mostLiked = "MostLiked",
  followingFeeds = "FollowingsFeeds",
  relatedVideos = "RelatedVideos",
  live = "Live",
  noVideoAvailable = "No videos available",
  like = "Like",
  clientFavoriteVideos = "ClientFavoriteVideos",
  delete = "Delete",
  primary = "Primary",
  manageVideos = "ManageVideos",
  clientPaymentAddCard = "ClientPaymentAddCard",
  clientBilling = "ClientBilling",
  HealingSky = "Healing Sky",
  signSSOLogin = "SSOLogin",
  loginPopup = "LoginPopup",
  registerPopup = "RegisterPopup",
  otpModel = "otpModel",
  pleaseWait = "Please Wait...",
  active = "active",
  inactive = "inactive",
}

export const isValidLoader = (sdd: any = []) => {
  return Array.isArray(sdd) ? (sdd?.length > 0 ? false : true) : true;
};
